import { Modal, ModalFuncProps } from 'antd';
import { useState } from 'react';
import StayStep from './StayStep';
import CancelReasonStep from './CancelReasonStep';

const CancelModal = ({ open, onOk, onCancel }: ModalFuncProps) => {
  const [step, setStep] = useState<number>(1);

  return (
    <Modal
      closable={false}
      footer={null}
      open={open}
      onCancel={onCancel}
      centered
    >
      <div className="flex-col gap-16">
        {step === 1 && <StayStep onCancel={onCancel} setStep={setStep} />}
        {step === 2 && <CancelReasonStep onCancel={onCancel} setStep={setStep} onOk={onOk} />}
    </div>
</Modal>
)
  ;
};

export default CancelModal;
